class ProductSwatch extends HTMLElement {
  constructor() {
    super();
    this.boundMouseOver = this.handleMouseOver.bind(this);
    this.boundMouseOut = this.handleMouseOut.bind(this);
  }

  connectedCallback() {
    this.addEventListener("mouseover", this.boundMouseOver);
    this.addEventListener("mouseout", this.boundMouseOut);
  }

  disconnectedCallback() {
    this.removeEventListener("mouseover", this.boundMouseOver);
    this.removeEventListener("mouseout", this.boundMouseOut);
  }

  handleMouseOver() {
    const productCardImage =
      this.closest(".product-item")?.querySelector(".image");
    if (!productCardImage) return;

    const imageUrl = this.dataset.image;
    const srcset = this.#buildSrcset(imageUrl);

    const pictureElement = document.createElement("picture");
    pictureElement.classList.add("swatch");
    const imageElement = document.createElement("img");
    imageElement.src = imageUrl;
    imageElement.srcset = srcset;
    imageElement.sizes = this.dataset.imageSizes || "1000px";
    imageElement.alt = "";
    imageElement.width = 400;
    imageElement.height = 400;
    pictureElement.appendChild(imageElement);

    productCardImage.appendChild(pictureElement);
    productCardImage.classList.add("swatch");
  }

  handleMouseOut() {
    const productCardImage =
      this.closest(".product-item")?.querySelector(".image");
    if (!productCardImage) return;

    const pictureElement = productCardImage.querySelector("picture.swatch");
    if (pictureElement) {
      pictureElement.remove();
    }
    productCardImage.classList.remove("swatch");
  }

  #buildSrcset(imageUrl) {
    if (!imageUrl) return "";

    const url = new URL(imageUrl, window.location.origin);
    const widths = [375, 550, 750, 900, 1100, 1250, 1500, 1780, 1950, 2100];
    const srcset = widths
      .map((width) => {
        url.searchParams.set("width", width.toString());
        return `${url.toString()} ${width}w`;
      })
      .join(", ");
    return srcset;
  }
}

customElements.define("product-swatch", ProductSwatch);
